module.exports = __webpack_public_path__ + "img/p3-desc.a976b17f.jpg";